'use es6';

import { removeConfigNulls } from './removeConfigNulls';
export const normalizations = {
  removeConfigNulls
};